import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getPlinkoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/plinko-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getLimboGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/limbo-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getMineGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/mine-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getCoinHeistGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/coin-heist-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getHiloGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/hilo-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getDiceGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/dice-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getAllGameSettingsService = () => {
  return axiosInstance(METHOD_TYPES.get, '/games/settings', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getCoinFlipGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/coin-flip-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getKenoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/keno-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getRouletteGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/roulette-game', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}
